import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/system/user/page', data, {
    trim: true
  })
}

// 创建
export function create (data) {
  return request.post('/system/user/companyCreateAnchor', data)
}

// 新建员工
export function companyCreateUser (data) {
  return request.post('/system/user/companyCreateUser', data)
}

// 修改员工信息
export function companyUpdUser (data) {
  return request.post('/system/user/companyUpdUser', data)
}

// 修改
export function updateById (data) {
  return request.post('/system/user/companyUpdAnchor', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/system/user/delete/${id}`)
}

// 修改用户状态
export function updUserStatus (params) {
  return request.get(`/system/user/updUserStatus`, { params })
}

// 修改密码
export function updPassword (data) {
  return request.post('/system/user/updPassword', data)
}
